"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyMap = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
class MyMap extends Map {
    getKeys() {
        return Array.from(this.keys());
    }
    getValues() {
        const values = [];
        this.forEach((value) => values.push(value));
        return values;
    }
}
exports.MyMap = MyMap;
